import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { Key } from 'swr';

export interface StoreState {
  requestKeys: {
    [keyId: string]: Exclude<Key, null>;
  };
}

const initialState: StoreState = { requestKeys: {} };

export const swrSlice = createSlice({
  name: '~/components/SWRRequestKeys',
  initialState,
  reducers: {
    addRequestKey: {
      reducer: (
        state: StoreState,
        action: PayloadAction<Key, string, string>,
      ) => {
        if (action.payload) {
          state.requestKeys[action.meta] = action.payload;
        } else if (state.requestKeys[action.meta]) {
          delete state.requestKeys[action.meta];
        }
      },
      prepare: (keyId: string, key: Key) => ({
        payload: key,
        meta: keyId,
      }),
    },
    removeRequestKey: (state: StoreState, action: PayloadAction<string>) => {
      if (state.requestKeys[action.payload]) {
        delete state.requestKeys[action.payload];
      }
    },
  },
});

export const { addRequestKey, removeRequestKey } = swrSlice.actions;
export const swrReducer = swrSlice.reducer;
